import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";
import { ReactNode } from "react";

interface KpiCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: ReactNode;
  bgColor: string;
  iconColor: string;
  loading?: boolean;
}

const KpiCard = ({ title, value, subtitle, icon, bgColor, iconColor, loading }: KpiCardProps) => {
  if (loading) {
    return (
      <Card
        sx={{
          minHeight: 130,
          boxShadow: "0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px -1px rgba(0,0,0,.1)",
          borderRadius: 2,
        }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width="60%" height={20} />
          <Skeleton width="40%" height={36} sx={{ mt: 1 }} />
          <Skeleton width="50%" height={16} sx={{ mt: 0.5 }} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card
      sx={{
        minHeight: 130,
        bgcolor: bgColor,
        boxShadow: "0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px -1px rgba(0,0,0,.1)",
        borderRadius: 2,
        transition: "box-shadow 0.2s, transform 0.2s",
        "&:hover": {
          boxShadow: "0 4px 12px 0 rgba(0,0,0,.15)",
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", fontWeight: 500, fontSize: 13, mb: 0.5 }}
            >
              {title}
            </Typography>
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, color: "text.primary", lineHeight: 1.2 }}
            >
              {value}
            </Typography>
            {subtitle && (
              <Typography
                variant="caption"
                sx={{ color: "text.secondary", fontSize: 11, mt: 0.5, display: "block" }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: iconColor,
              color: "#fff",
              fontSize: 20,
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default KpiCard;
